import actions from './actions';
import types from './constants';
import services from '../../services/dyslexia';
import { generateDyslexiaReport } from '../../util/generators/generateDyslexiaReport';
import get from 'lodash.get';

const dyslexiaSort = (sort) => (dispatch) => {
  dispatch(actions[types.DYSLEXIA_SORT](sort));
};

const fetchReport = (classroomId, selectedBenchmark, selectedLocale) => (dispatch, getState) => {
  const state = getState()
  const window = get(state, "reports.teacher.selectedScreeningWindow")
  const cachedDyslexiaData = get(state, `reports.dyslexia.report.cachedData.${classroomId}`)
  dispatch(actions[types.DYSLEXIA_PENDING]())
  
  services.fetchScores(classroomId, window, cachedDyslexiaData, dispatch).then((scores) => {
    let dyslexiaReport = generateDyslexiaReport(scores, selectedBenchmark, selectedLocale);
    dispatch(actions[types.DYSLEXIA_COMPLETE](dyslexiaReport));
  })
  .catch((e) => {
    dispatch(actions[types.DYSLEXIA_ERROR](e.message))
  });
};

const scaleReport = (report, selectedBenchmark) => (dispatch) => {
  let dyslexiaReport = null;
  if(report && report.scores) {
    dyslexiaReport = generateDyslexiaReport(report.scores, selectedBenchmark);
  }
  dispatch(actions[types.DYSLEXIA_COMPLETE](dyslexiaReport));
};

export default {
  fetchReport,
  scaleReport,
  dyslexiaSort
};